export { default } from './OpenFinanceBanner';
